import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRight } from 'lucide-react';
export function DecisionRapida() {
  const options = [{
    need: 'Quiero empezar con poco dinero',
    system: 'AMAZON FBA',
    url: 'https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos'
  }, {
    need: 'Quiero vender sin inventario',
    system: 'AMAZON FBM',
    url: 'https://43skvt-1y.myshopify.com/products/aprende-a-vender-en-amazon-fbm-desde-cero'
  }, {
    need: 'Quiero aprender FBA + FBM juntos',
    system: 'SISTEMA COMPLETO AMAZON',
    url: 'https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026',
    secondary: true
  }, {
    need: 'Quiero trabajar con marcas reconocidas',
    system: 'AMAZON WHOLESALE',
    url: 'https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-wholesale-desde-cero-2026'
  }, {
    need: '🏆 Quiero aprender todo y tener el sistema más completo',
    system: 'AMAZON MASTER SYSTEM™',
    url: 'https://43skvt-1y.myshopify.com/products/amazon-master-system%E2%84%A2-2026-fba-fbm-wholesale-bonos-premium',
    highlight: true
  }];
  return <section className="bg-brand-beige py-16 md:py-20 px-5 sm:px-6" data-id="element-151">
      <div className="max-w-3xl mx-auto" data-id="element-152">
        <FadeIn data-id="element-153">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-brand-green text-center mb-3 tracking-tight" data-id="element-154">
            ¿Qué sistema es mejor para ti?
          </h2>
          <p className="text-sm text-brand-text/60 text-center mb-10 max-w-xl mx-auto" data-id="element-155">
            Haz clic en la opción que mejor describa tu situación y te
            llevaremos directamente al sistema recomendado.
          </p>
        </FadeIn>

        <div className="space-y-4" data-id="element-156">
          {options.map((opt, i) => <FadeIn key={i} delay={0.05 * i} data-id="element-157">
              <button type="button" onClick={() => window.open(opt.url, '_blank', 'noopener,noreferrer')} className={`group w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4 rounded-2xl px-5 py-5 sm:px-6 sm:py-5 border text-left transition-all duration-200 hover:-translate-y-0.5 ${opt.highlight ? 'bg-brand-green border-brand-gold/50 shadow-lg hover:shadow-xl hover:bg-brand-green/95' : opt.secondary ? 'bg-white border-brand-gold/60 shadow-md hover:shadow-lg hover:border-brand-gold' : 'bg-white border-brand-text/8 shadow-sm hover:shadow-md hover:border-brand-green/30'}`} data-id="element-158">
                <span className={`text-base font-medium ${opt.highlight ? 'text-white' : opt.secondary ? 'text-brand-text' : 'text-brand-text/80'}`} data-id="element-159">
                  {opt.need}
                </span>
                <span className="flex items-center gap-2 flex-shrink-0" data-id="element-160">
                  <span className={`text-sm sm:text-base font-bold whitespace-nowrap ${opt.highlight ? 'text-brand-gold' : 'text-brand-green'}`} data-id="element-161">
                    {opt.system}
                  </span>
                  <ArrowRight className={`w-4 h-4 transition-transform duration-200 group-hover:translate-x-1 ${opt.highlight ? 'text-brand-gold' : 'text-brand-green'}`} data-id="element-162" />
                </span>
              </button>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}